export class ContactDetailsPersistentModel {
	
	email?: string;
	firstName?: string;
	lastName?: string;
	address1?: string;
	address2?: string;
	city?: string;
	state?: string;
	country?: string;
	zipcode?: string;
	phone?: string;
	loginName?: string;
}
